const doodAmountMap: { [key: string]: number } = {
  Doodles: 185000,
  SpaceDoodles: 185000,
  Dooplicator: 9000,
  GenesisBox: 2250,
  iconic: 8500,
  grail: 600,
  exclusive: 125,
  essential: 25,
  Posters: 15,
  BetaPass: 80,
  DoodlesCertifiedViral: 25,
  Pass: 6,
};

const spaceMilesMultiplicationFactor = 1000000000;

/**
 * Calculates the available amount to claim based on the number of assets and their type.
 * @function calculateAvailableToClaim
 * @param {number} amountOfAssets - The number of assets.
 * @param {string} assetType - The type of the asset.
 * @returns {number} The available amount to claim.
 */
export function calculateAvailableToClaim(
  amountOfAssets: number,
  assetType: string,
): number {
  const doodAmount = doodAmountMap[assetType];
  if ((!doodAmount || amountOfAssets <= 0) && assetType !== 'SpaceMiles') {
    console.error(`Invalid assetType: ${assetType}`);
    return 0;
  }

  if (assetType === 'SpaceMiles') {
    return amountOfAssets * spaceMilesMultiplicationFactor;
  }
  if (amountOfAssets === 1) {
    return doodAmount ?? 0;
  }

  return Math.round(amountOfAssets * (doodAmount ?? 0));
}
